import { FC } from "react";

const SVGIconFlightmode:FC = () => {
    return(
        <svg width="24px" height="24px" viewBox="0,0,256,256"><g><g transform="scale(8.53333,8.53333)"><path d="M9,3l2.72656,10h-6.32617l-2.40039,-4h-1v5v3v4h1l2.40039,-4h6.32617l-2.72656,10h2l7.27344,-10h7.72656c1.105,0 2,-0.895 2,-2c0,-1.105 -0.895,-2 -2,-2h-7.72656l-7.27344,-10z"></path></g></g></svg>
    );
}

export default SVGIconFlightmode;